var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDummyImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 162467",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.19 11.44H15.25a3.81 3.81 0 0 0-3.81 3.81v41.94A3.81 3.81 0 0 0 15.25 61h41.94A3.81 3.81 0 0 0 61 57.19V15.25a3.81 3.81 0 0 0-3.81-3.81Zm0 45.75H15.25V15.25h41.94Z",
    "data-name": "Path 1247"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81 3.81h41.94v3.81h3.81v-3.8A3.81 3.81 0 0 0 45.75 0H3.81A3.81 3.81 0 0 0 0 3.81v41.94a3.81 3.81 0 0 0 3.81 3.81h3.81v-3.81h-3.8Z",
    "data-name": "Path 1248"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.97 47.66h30.5a1.9 1.9 0 0 0 1.35-3.26l-7.63-7.63a1.9 1.9 0 0 0-2.68 0l-2.48 2.48-6.26-6.27a1.9 1.9 0 0 0-2.7 0L19.65 44.42a1.9 1.9 0 0 0 1.33 3.24Z",
    "data-name": "Path 1249"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.81,
    cy: 3.81,
    r: 3.81,
    "data-name": "Ellipse 53",
    transform: "translate(41.94 24.78)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyImg);
export default __webpack_public_path__ + "static/media/dummy-img.3892faa771acd7f2e96dec47f5156526.svg";
export { ForwardRef as ReactComponent };